export enum LiningWeight {
  Blackout = "Blackout",
  Standard = "Standard",
}

export enum StackingStyle {
  Waterfall = "Waterfall",
  Standard = "Standard",
}

export enum HeadingType {
  PencilPleat = "Pencil pleat",
  DoublePinch = "Double pinch pleat",
  TriplePleat = "Triple pinch pleat",
  Eyelet = "Eyelet",
}

export type RomanBlindConfiguration = {
  stackingStyle: StackingStyle;
  width: number;
  height: number;
  installationHeight: number;
  liningWeight: LiningWeight;
  liningColour: string;
  controlSide: string;
};

export type CurtainConfiguration = {
  headingType: HeadingType;
  lengthOfTrackOrPole: number;
  eyeDrop: number;
  liningWeight: LiningWeight;
  liningColour: string;
  eyeletColour?: string;
  typeOfCurtain: string;
};

export type RollerBlindConfiguration = {
  recess: string;
  width: number;
  height: number;
  rollDirection: string;
  chainSide: string;
  chainColour: string;
  installationHeight: number;
};

export type MadeToMeasureConfiguration =
  | RomanBlindConfiguration
  | CurtainConfiguration
  | RollerBlindConfiguration;
